var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5991",
    "data-name": "Rectangle 5991",
    width: 65,
    height: 65,
    transform: "translate(-10257 17314)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_667",
    "data-name": "Mask Group 667",
    transform: "translate(10257 -17314)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36462",
    "data-name": "Group 36462",
    transform: "translate(-10304.688 17270.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57450",
    "data-name": "Path 57450",
    d: "M75.394,74.241H54.533A2.843,2.843,0,0,1,51.688,71.4V50.537a2.843,2.843,0,0,1,2.844-2.844H75.391a2.851,2.851,0,0,1,2.848,2.844V71.4a2.851,2.851,0,0,1-2.848,2.844ZM54.533,49.589a.95.95,0,0,0-.949.948V71.4a.95.95,0,0,0,.949.948H75.391a.95.95,0,0,0,.949-.948V50.537a.95.95,0,0,0-.949-.948Z",
    fill: "#758522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57451",
    "data-name": "Path 57451",
    d: "M75.394,104.582H54.533a2.843,2.843,0,0,1-2.844-2.844V80.878a2.843,2.843,0,0,1,2.844-2.849H75.391a2.851,2.851,0,0,1,2.848,2.844v20.859a2.85,2.85,0,0,1-2.848,2.844ZM54.533,79.929a.95.95,0,0,0-.949.948v20.859a.95.95,0,0,0,.949.948H75.391a.95.95,0,0,0,.949-.948V80.878a.95.95,0,0,0-.949-.948Z",
    fill: "#758522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57452",
    "data-name": "Path 57452",
    d: "M105.735,104.582H84.877a2.844,2.844,0,0,1-2.843-2.844V80.878a2.843,2.843,0,0,1,2.843-2.844h20.858a2.845,2.845,0,0,1,2.844,2.844v20.859a2.846,2.846,0,0,1-2.844,2.845ZM84.878,79.929a.947.947,0,0,0-.949.948v20.859a.95.95,0,0,0,.949.948h20.857a.949.949,0,0,0,.948-.948V80.878a.949.949,0,0,0-.948-.949Z",
    fill: "#758522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57453",
    "data-name": "Path 57453",
    d: "M105.735,74.241H84.877A2.843,2.843,0,0,1,82.034,71.4V50.537a2.843,2.843,0,0,1,2.843-2.844h20.858a2.845,2.845,0,0,1,2.844,2.844V71.4a2.844,2.844,0,0,1-2.844,2.845ZM84.877,49.589a.947.947,0,0,0-.949.948V71.4a.95.95,0,0,0,.949.948h20.858a.949.949,0,0,0,.948-.948V50.537a.949.949,0,0,0-.948-.948Z",
    fill: "#758522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57454",
    "data-name": "Path 57454",
    d: "M101.943,61.916H88.671a.95.95,0,0,1,0-1.9h13.272a.95.95,0,0,1,0,1.9Z",
    fill: "#758522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57455",
    "data-name": "Path 57455",
    d: "M101.943,89.412H88.671a.95.95,0,0,1,0-1.9h13.272a.95.95,0,0,1,0,1.9Z",
    fill: "#758522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57456",
    "data-name": "Path 57456",
    d: "M101.943,95.1H88.671a.95.95,0,1,1,0-1.9h13.272a.95.95,0,0,1,0,1.9Z",
    fill: "#758522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57457",
    "data-name": "Path 57457",
    d: "M72.55,60.971a.95.95,0,0,1-.949.948H65.915v5.689a.95.95,0,0,1-1.9,0V61.915H58.327a.95.95,0,0,1,0-1.9h5.687V54.33a.95.95,0,0,1,1.9,0v5.689H71.6a.95.95,0,0,1,.949.948Z",
    fill: "#758522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57458",
    "data-name": "Path 57458",
    d: "M70.332,95.328a.954.954,0,0,1-.675,1.627.938.938,0,0,1-.67-.281l-4.022-4.02-4.022,4.02a.94.94,0,0,1-.67.281.953.953,0,0,1-.675-1.627l4.022-4.02L59.6,87.288a.951.951,0,0,1,1.345-1.346l4.022,4.02,4.022-4.02a.951.951,0,1,1,1.345,1.346l-4.022,4.02Z",
    fill: "#758522"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaryIcon);
export default __webpack_public_path__ + "static/media/DiaryIcon.677180e9e1d64043aab9c7f9f0a33c39.svg";
export { ForwardRef as ReactComponent };